import startOfISOWeekYear from'../startOfISOWeekYear/index.js';import addWeeks from'../addWeeks/index.js';import requiredArgs from'../_lib/requiredArgs/index.js';var MILLISECONDS_IN_WEEK=604800000;/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of ISO weeks in a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * var result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */export default function getISOWeeksInYear(dirtyDate){requiredArgs(1,arguments);var thisYear=startOfISOWeekYear(dirtyDate);var nextYear=startOfISOWeekYear(addWeeks(thisYear,60));var diff=nextYear.valueOf()-thisYear.valueOf();// Round the number of weeks to the nearest integer
// because the number of milliseconds in a week is not constant
// (e.g. it's different in the week of the daylight saving time clock shift)
return Math.round(diff/MILLISECONDS_IN_WEEK);}